module.exports = __webpack_public_path__ + "static/media/moons_ortodoncia_invisible-375.34e93732.jpg";